export default __webpack_public_path__ + "static/media/commentInstagram.05d91478.svg";